import React from 'react';

interface IProps {
  children: JSX.Element;
}

export function PlatformBox({ children }: IProps): JSX.Element {
  return <div className="platform__box">{children}</div>;
}
